export const announceCookieChange = () => {
	const event = new Event("cookieChange");
	document.dispatchEvent(event);
};
